import * as yup from 'yup'
import { useEffect, useState } from 'react'
import Style from './style.module.css'
import { useFormik } from 'formik'
import { Alert, Snackbar } from '@mui/material'
import LeftSidePopupLayout from '../../../../../component/popup/modal-layout'
import { useApiCall } from '../../../../../component/custom-hooks/api-call'
import { FormArea, FeildWraper, FeildError, FormLabel, SelectSearch } from '../../../../../component/form/form-layout'
import moment from 'moment'

const StockSupplyEditPopup = ({ onClose = () => { }, onError = () => { }, onSubmit = () => { }, currentData, dropdowns, tabIndex }) => {
    console.log("StockSupplyEditPopup DATA : ", currentData)

    const apiCall = useApiCall();
    const [alertData, setAlertData] = useState({ isShow: false });
    const validationSchema = yup.object({
        date: yup
            .string()
            .required("Date is required")
            .test(
                "valid-date",
                "Invalid date",
                (value) =>
                    value && moment(value, "YYYY-MM-DD", true).isValid()
            ),

        item_id: yup
            .number()
            .typeError("Item is required")
            .required("Item is required"),

        variant_id: yup
            .number()
            .typeError("Variant is required")
            .required("Variant is required"),

        quantity: yup
            .number()
            .typeError("Quantity must be a number")
            .positive("Quantity must be greater than 0")
            .required("Quantity is required"),

        total_amount: yup
            .number()
            .typeError("Amount must be a number")
            .positive("Amount must be greater than 0")
            .required("Total amount is required"),

        vendor_id: yup
            .number()
            .typeError("Vendor is required")
            .required("Vendor is required"),

        bill_receipt_number: yup
            .string()
            .transform(v => (v === "-" ? "" : v))
            .required("Bill receipt number is required"),

        location_id: yup
            .number()
            .typeError("Building is required")
            .required("Building is required"),
    });

    const formatDateForInput = (dateStr) => {
        if (!dateStr) return "";
        return moment(dateStr, "DD-MMM-YYYY").format("YYYY-MM-DD");
    };

    const extractAmount = (amount) => {
        if (!amount) return "";
        return amount.replace(/[^0-9.]/g, ""); // 7920.00
    };

    useEffect(() => {
        if (currentData?.id) {
            formik.setFieldValue("date", formatDateForInput(currentData?.date));
            formik.setFieldValue("item_id", currentData?.item_id);
            formik.setFieldValue("variant_id", currentData?.variant_id);
            formik.setFieldValue("quantity", currentData?.quantity);
            formik.setFieldValue("total_amount", extractAmount(currentData?.total_amount));
            formik.setFieldValue("vendor_id", currentData?.vendor_id);
            formik.setFieldValue("bill_receipt_number", currentData?.bill_receipt_number);
            formik.setFieldValue("location_id", currentData?.location_id);
            formik.setFieldValue("notes", currentData?.notes);
        }
    }, [currentData?.id]);

    const handleClose = () => {
        setAlertData({ isShow: false })
    }

    const formik = useFormik({
        initialValues: {
            date: "",
            item_id: "",
            variant_id: "",
            quantity: "",
            total_amount: "",
            vendor_id: "",
            bill_receipt_number: "",
            location_id: "",
            notes: "",
        },
        enableReinitialize: true,
        validationSchema,
        onSubmit: async (values) => {
            const apiData = JSON.stringify({
                purchases: [
                    {
                        id: currentData?.id,
                        date: values.date,
                        item_id: values.item_id,
                        variant_id: values.variant_id,
                        quantity: values.quantity,
                        total_amount: values.total_amount,
                        vendor_id: values.vendor_id,
                        bill_receipt_number: values.bill_receipt_number,
                        location_id: values.location_id,
                        notes: values.notes,
                    }
                ]
            });

            try {
                const resp = await apiCall({ method: "post", url: `update-purchase-item`, data: apiData });
                onSubmit(resp?.message || `Request Submitted`);
                formik.resetForm();
            } catch (error) {
                onError(error?.response.data?.respMsg || error?.response.data?.responseMessage || error?.response.data?.message || "Some Thing Went Wrong")
            }
        }
    });

    return (
        <>
            <div className={Style.modal_body}>
                <LeftSidePopupLayout popupStatus={true} className={`${Style.departmentChangeModal}`}>
                    <form onSubmit={formik.handleSubmit} className={Style.modal_main}>
                        <div className={Style.modal_body}>
                            <FormArea>
                                <FeildWraper>
                                    <FormLabel required>Date</FormLabel>
                                    <input
                                        type={'date'}
                                        name={'date'}
                                        onChange={formik.handleChange}
                                        value={formik.values.date}
                                        placeholder='Company Name'
                                    />
                                    {formik.touched.date && formik.errors.date && (
                                        <FeildError>{formik.errors.date}</FeildError>
                                    )}
                                </FeildWraper>

                                <FeildWraper>
                                    <FormLabel required>Items</FormLabel>
                                    <SelectSearch
                                        menuPosition="fixed"
                                        name='item_id'
                                        value={formik.values.item_id}
                                        onChange={(v) => formik.setFieldValue(`item_id`, v)}
                                        options={dropdowns?.items?.map(i => ({
                                            label: i.name,
                                            value: i.id,
                                        }))}
                                        placeholder='Select Items'
                                    />

                                    {formik.touched.item_id && formik.errors.item_id && (
                                        <FeildError>{formik.errors.item_id}</FeildError>
                                    )}
                                </FeildWraper>

                                <FeildWraper>
                                    <FormLabel required>Variant</FormLabel>
                                    <SelectSearch
                                        menuPosition="fixed"
                                        value={formik.values.variant_id}
                                        onChange={(v) => formik.setFieldValue(`variant_id`, v)}
                                        options={dropdowns?.variants?.map(v => ({
                                            label: v.name,
                                            value: v.id,
                                        }))}
                                        placeholder='Select Variant'
                                    />
                                    {formik.touched.variant_id && formik.errors.variant_id && (
                                        <FeildError>{formik.errors.variant_id}</FeildError>
                                    )}
                                </FeildWraper>

                                <FeildWraper>
                                    <FormLabel required>Quantity</FormLabel>
                                    <input
                                        name='quantity'
                                        type="number"
                                        value={formik.values.quantity}
                                        onChange={formik.handleChange}
                                        placeholder='Quantity'
                                    />
                                    {formik.touched.quantity && formik.errors.quantity && (
                                        <FeildError>{formik.errors.quantity}</FeildError>
                                    )}
                                </FeildWraper>

                                <FeildWraper>
                                    <FormLabel required>Total Amount</FormLabel>
                                    <input
                                        name='total_amount'
                                        type="number"
                                        value={formik.values.total_amount}
                                        onChange={formik.handleChange}
                                        placeholder='Total Amount'
                                    />
                                    {formik.touched.total_amount && formik.errors.total_amount && (
                                        <FeildError>{formik.errors.total_amount}</FeildError>
                                    )}
                                </FeildWraper>

                                <FeildWraper>
                                    <FormLabel required>Vendor</FormLabel>
                                    <SelectSearch
                                        value={formik.values.vendor_id}
                                        onChange={(v) => formik.setFieldValue("vendor_id", v)}
                                        options={dropdowns?.vendor?.map(v => ({
                                            label: v.full_name,
                                            value: v.id,
                                        }))}
                                        placeholder='Select Vendor'
                                    />
                                    {formik.touched.vendor_id && formik.errors.vendor_id && (
                                        <FeildError>{formik.errors.vendor_id}</FeildError>
                                    )}
                                </FeildWraper>

                                <FeildWraper>
                                    <FormLabel required>Bill Receipt Number</FormLabel>
                                    <input
                                        name='bill_receipt_number'
                                        type="text"
                                        value={formik.values.bill_receipt_number}
                                        onChange={formik.handleChange}
                                        placeholder='Bill Receipt Number'
                                    />
                                    {formik.touched.bill_receipt_number && formik.errors.bill_receipt_number && (
                                        <FeildError>{formik.errors.bill_receipt_number}</FeildError>
                                    )}
                                </FeildWraper>

                                <FeildWraper>
                                    <FormLabel required>Building</FormLabel>
                                    <SelectSearch
                                        value={formik.values.location_id}
                                        onChange={(v) => formik.setFieldValue("location_id", v)}
                                        options={dropdowns?.buildings?.map(b => ({
                                            label: b.name,
                                            value: b.id,
                                        }))}
                                        placeholder='Select Building'
                                    />
                                    {formik.touched.location_id && formik.errors.location_id && (
                                        <FeildError>{formik.errors.location_id}</FeildError>
                                    )}
                                </FeildWraper>

                                <FeildWraper width='100%'>
                                    <FormLabel>Notes</FormLabel>
                                    <textarea
                                        type={'text'}
                                        name={'Notes'}
                                        onChange={formik.handleChange}
                                        value={formik.values.notes}
                                        placeholder='Notes'
                                    />
                                    {formik.touched.notes && formik.errors.notes && (
                                        <FeildError>{formik.errors.notes}</FeildError>
                                    )}
                                </FeildWraper>
                            </FormArea>
                        </div>

                        <div className={Style.modal_foot}>
                            <button type='reset' className={`${Style.dcmb__cancel}`} onClick={onClose}>Discard</button>
                            <button type='submit' className={`${Style.dcmb__submit}`}>Apply</button>
                        </div>
                    </form>
                </LeftSidePopupLayout>
            </div>
            <Snackbar open={alertData?.isShow} autoHideDuration={3000} onClose={handleClose}>
                <Alert
                    onClose={handleClose}
                    severity={alertData?.type}
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {alertData?.message}
                </Alert>
            </Snackbar>
        </>
    )
}

export default StockSupplyEditPopup
